import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-page-bg flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-sm p-8 max-w-md w-full text-center">
            <img src="/assets/brand/byrdsense-icon-color.svg" alt="Byrdsense" className="w-16 mx-auto mb-6 opacity-40" />
            <AlertTriangle className="w-10 h-10 text-unsatisfactory mx-auto mb-3" />
            <h2 className="text-lg font-bold text-slate-800 mb-2">Something went wrong</h2>
            <p className="text-sm text-slate-500 mb-6">
              The page encountered an error. This is usually temporary.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleRetry}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold
                  bg-white text-slate-600 shadow-sm border border-slate-200
                  hover:bg-slate-50 transition"
              >
                <RefreshCw className="w-4 h-4" />
                Try Again
              </button>
              <button
                onClick={this.handleReload}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold
                  text-white bg-gradient-to-r from-navy to-navy-light
                  hover:from-navy-dark hover:to-navy transition shadow-sm"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
